import styled from "styled-components/macro";

import AmericanExpress from "./AmericanExpress";
import BankAccount from "./BankAccount";
import Discover from "./Discover";
import Mastercard from "./Mastercard";
import Visa from "./Visa";

export default function CardBackgrounds({ cardType }) {
  return (
    <Wrapper>
      {cardType === "visa" && <Visa />}
      {cardType === "mastercard" && <Mastercard />}
      {cardType === "amex" && <AmericanExpress />}
      {cardType === "discover" && <Discover />}
      {cardType === "checking" && <BankAccount />}
      {cardType === "savings" && <BankAccount />}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
